export default __webpack_public_path__ + "static/media/linxe_icon.d8a7f32d.png";